import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createPricePlanCalculator(
  parentId: string,
  masterBlockId?: MasterBlockId,
): PricePlanCalculatorInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.PricePlanCalculator,
    parentId: parentId,
    masterBlockId: masterBlockId,
    popupId: null,
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.PricePlanCalculator),
  }
}
